import React from 'react';
import SEO from '../components/SEO';

import { useTranslation } from '../hooks/useTranslation';

const PrivacyPolicy = () => {
  const { isBrazil } = useTranslation();
  return (
    <div className="pt-24 pb-24 bg-[#030303] min-h-screen">
      <SEO 
        title={isBrazil ? "Política de Privacidade" : "Privacy Policy"}
        description={isBrazil ? "Compromisso da PlataPost com sua privacidade e segurança de dados." : "PlataPost's commitment to your privacy and data security."}
      />

      <div className="max-w-4xl mx-auto px-6 py-12 glass-card rounded-[3rem] border border-white/5 relative overflow-hidden">
        <div className="absolute top-0 right-0 w-64 h-64 bg-indigo-500/5 blur-[80px] -mr-32 -mt-32" />
        <h1 className="text-4xl lg:text-5xl font-black text-white mb-8 tracking-tighter leading-tight">{isBrazil ? "Política de Privacidade" : "Privacy Policy"}</h1>
        
        <p className="text-indigo-500 font-black uppercase tracking-widest text-[10px] mb-12">{isBrazil ? "Última Atualização: 2 de Maio de 2026" : "Last Updated: May 1, 2026"}</p>

        <div className="space-y-12 text-gray-400 font-medium leading-relaxed">
          <section>
            <h2 className="text-2xl font-black text-white mb-4 tracking-tight">{isBrazil ? "1. Introdução" : "1. Introduction"}</h2>
            <p>
              {isBrazil ? "A PlataPost se dedica a proteger sua privacidade. Esta Política explica como coletamos e usamos suas informações." : "PlataPost (\"we,\" \"our,\" or \"us\") is dedicated to protecting your privacy. This Privacy Policy explains how we collect, use, and share information about you when you use our website and AI-powered social media management services."}
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-black text-white mb-4 tracking-tight">2. Information We Collect</h2>
            <p className="mb-4">
              We collect information you provide directly to us, such as when you create an account, fill out your brand profile, or communicate with us. This may include:
            </p>
            <ul className="list-disc pl-6 space-y-2 text-indigo-400">
              <li>Name and contact information</li>
              <li>Brand strategy and mission details</li>
              <li>Social media account details (if connected)</li>
              <li>Payment information</li>
            </ul>
          </section>

          <section>
            <h2 className="text-2xl font-black text-white mb-4 tracking-tight">3. Use of AI and Data</h2>
            <p>
              We use advanced AI models (such as Google Gemini) to process the brand data you provide. This data is used solely to generate content for your specific brand and is not used to train global AI models in a way that would expose your proprietary strategy to other users.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-black text-white mb-4 tracking-tight">4. Sharing of Information</h2>
            <p>
              We do not sell your personal information. We may share information with third-party service providers (such as Stripe for payments or Firebase for data storage) to help us provide our services.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-black text-white mb-4 tracking-tight">5. Your Rights</h2>
            <p>
              You have the right to access, correct, or delete your personal information at any time through your account settings or by contacting our support team.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-black text-white mb-4 tracking-tight">6. Contact Us</h2>
            <p>
              If you have any questions about this Privacy Policy, please contact us at <span className="text-indigo-400 font-black">support@platapost.com</span>.
            </p>
          </section>
        </div>
      </div>
    </div>
  );
};

export default PrivacyPolicy;
